import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=454f79cb&scoped=true&"
import script from "./event-detail.vue?vue&type=script&lang=js&"
export * from "./event-detail.vue?vue&type=script&lang=js&"
import style0 from "./event-detail.vue?vue&type=style&index=0&id=454f79cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f79cb",
  null
  
)

export default component.exports